module.exports = __webpack_public_path__ + "img/c84cfc2.png";